var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19C21.4477 19 21 19.4477 21 20C21 20.5523 21.4477 21 22 21V19ZM28 21C28.5523 21 29 20.5523 29 20C29 19.4477 28.5523 19 28 19V21ZM22 21H28V19H22V21Z",
    fill: "#0F90FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14C21.4477 14 21 14.4477 21 15C21 15.5523 21.4477 16 22 16V14ZM28 16C28.5523 16 29 15.5523 29 15C29 14.4477 28.5523 14 28 14V16ZM22 16H28V14H22V16Z",
    fill: "#0F90FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99756 15.5C7.99756 13.0147 10.0123 11 12.4976 11C14.9828 11 16.9976 13.0147 16.9976 15.5C16.9976 17.9853 14.9828 20 12.4976 20C10.0123 20 7.99756 17.9853 7.99756 15.5Z",
    stroke: "#0F90FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.2298C7.3098 23.0198 8.01349 21.9474 9.00012 21.1815C9.98676 20.4157 11.2002 20 12.4492 20C13.6982 20 14.9117 20.4157 15.8983 21.1815C16.885 21.9474 17.5886 23.0198 17.8984 24.2298",
    stroke: "#0F90FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9C3 7.89543 4.03319 7 5.30769 7H30.6923C31.9668 7 33 7.89543 33 9V27C33 28.1046 31.9668 29 30.6923 29H5.30769C4.03319 29 3 28.1046 3 27V9Z",
    stroke: "#0F90FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalData);
export default __webpack_public_path__ + "static/media/personal-data.eba42c997d06aa23fddfb763a1b7d79d.svg";
export { ForwardRef as ReactComponent };